import $ from "jquery";
// import 'jquery-ui';
import OrthoPlanControls from "./OrthoPlanControls.vue";
import OriginalTeethOpacity from "./OriginalTeethOpacity.vue";
import OrthoPlanButtons from "./OrthoPlanButtons.vue";
import OrthoPlayControls from "./OrthoPlayControls.vue";
import OrthoTreatmentControls from "./treatment/OrthoTreatmentControls.vue";
import OrthoStageDialog from "./OrthoStageDialog.vue";
import {
  positiveZero,
  radiansToDegrees,
  getBufferGeometry,
} from "../geometry/geometry";
import {
  enterMoveMode,
  exitMoveMode,
  moveModeMouseDown,
  moveModeMouseMove,
  moveModeMouseUp,
  moveModeValueChanged,
  moveByTag,
  moveModeTagDetected,
  redrawMoveArrow,
} from "../newMove/newMoveMode";
import {
  enterRotateMode,
  exitRotateMode,
  rotateModeValueChanged,
  rotateByTag,
  rotateModeMouseDown,
  rotateModeMouseMove,
  rotateModeMouseUp,
} from "../newRotate/newRotateMode";
import { saveViewerData } from "../saveLoadData";
import { getGeometryFromStl } from "@/components/geometry/geometryLoader.js";
import {
  sendGetStageLinksRequest,
  sendOrthoSaveStageRequest,
  sendOrthoRemoveStageRequest,
} from "@/api/orthoApi";
import { STLExporter } from "three/addons/exporters/STLExporter.js";
import { smoothGeometry, toLegacyGeometry } from "@/components/geometry/legacy";
import { globalPlanes, empty } from "@/components/reports/ClipDialog.vue";
import {
  ioViewer,
  ioPlane,
  enterIntraoralOrtho,
  allModels,
  gingivae as ioGingivae,
  gingivae,
} from "../intraoral/IntraoralManager";
import {
  SUBTRACTION,
  ADDITION,
  REVERSE_SUBTRACTION,
  INTERSECTION,
  DIFFERENCE,
  HOLLOW_SUBTRACTION,
  HOLLOW_INTERSECTION,
  Brush,
  Evaluator,
} from "three-bvh-csg";
import { loadGingivaCrossData } from "@/components/geometry/gingivaHelper";
import { drawLine, drawPoint } from "../draw/draw.js";
import {
  generateRootCrownMeshes,
  isAnchorDataInitialized,
} from "@/components/anchorage/AnchorageCalculation.js";

//#region fields
const STAGE_DATA_JSON = "stageData.json";
const ANIMATE_STAGE_MS = 2000;

let orthoViewer = null;
let controlsInitialized = false;
let playInterval = null;

let toothContext = {
  id: null,
  tooth: null,
  isMultiselect: false,
  selectedTeeth: [],
  defaultPosition: null,
  defaultBox: null,
  display: "none",
  isMoved: false,
  isRotated: false,
  isActive: false,
  isVertical: false,
  isApex: false,
  moveX: "0.0",
  moveY: "0.0",
  moveZ: "0.0",
  rotateX: "0.0",
  rotateY: "0.0",
  rotateZ: "0.0",
  showTapArrows: false,
  sliderValue: 0,
};

let playInitialized = false;

let collisionColor = 0xff4d00;
let collisionMaterial = new THREE.MeshPhongMaterial({
  color: collisionColor,
  flatShading: false,
  specular: collisionColor,
  emissive: collisionColor,
  shininess: 1,
  side: THREE.DoubleSide, // THREE.DoubleSide 2 FrontSide
  opacity: 1,
  transparent: false,
});
let multiselectColor = new THREE.Color("#FF0000");

let treatmentContext = {
  showOriginal: false,
  showRootCollisions: false,
  showAnchorageLoss: false,
  showUnknownRoots: false,
  isVisible: false,
};

let csgEvaluator = null;
let collisionsFound = false;
let anchorageLossFound = false;

//#endregion

let OrthoPlanMode = {
  isIntraoralView: false,
  isWhite: false,
  whiteColor: "#ffffff",
  blueColor: "#007bff",
  selectedId: null,
  isActive: false,
  isPlaying: false,
  useLatest: false,
  showOriginal: false,
  showExtracted: true,
  showCollisions: false,
  showAnchorageLoss: false,
  stageName: "STAGE 1",
  saveStage: false,
  highlightTagColor: 0xffff00,
  dicomIncompatible: true,
  toothSelected: function (tooth, event) {
    if (tooth && tooth.isTooth) {
      //  && toothContext.tooth != tooth
      console.log("toothSelected", tooth, event);
      if (
        tooth.isHidden ||
        !tooth.isVisible ||
        (vueApp.getFocusedTooth() && !tooth.isFocused)
      ) {
        return;
      }
      toothContext.isMultiselect = event.ctrlKey;

      if (!isAnchorDataInitialized) showLoader(true);
      setTimeout(() => {
        generateRootCrownMeshes();
        enterEditToothMode(tooth);
        if (toothContext.isMoved) {
          moveModeMouseDown(tooth, event);
        } else if (toothContext.isRotated) {
          rotateModeMouseDown(tooth, event);
        }
        hideLoader();
      }, 50);
    }
  },
  tagDetected: function (tag, tagMesh, isShift, intersectPoint) {
    // console.log("tagDetected", tag, tagMesh, isShift);
    if (toothContext.isMoved) {
      moveModeTagDetected(tag, tagMesh, isShift, intersectPoint);
      //   moveByTag(tag);
    } else if (toothContext.isRotated) {
      rotateByTag(tag);
    }
  },
  enterMode: function () {
    enterOrthoPlanMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveOrthoPlanMode(saveActiveMode);
  },
  mouseMove: function (event) {
    if (toothContext.isMoved) {
      moveModeMouseMove(event);
    } else if (toothContext.isRotated) {
      rotateModeMouseMove(event);
    }
    if (!toothContext.id) return true;
  },
  mouseUp: function (event, mesh) {
    if (toothContext.isMoved) {
      return moveModeMouseUp(event, mesh);
    } else if (toothContext.isRotated) {
      rotateModeMouseUp(event);
    } else {
      return true;
    }
  },
  doubleClick: function (event) {
    // console.log("ortho doubleClick", event);
    exitEditToothMode();
  },
  clearSelection: function () {
    enterMoveMode(null);
  },
};

export default {
  functional: true,
  props: ["currentStages"],
  components: {
    OrthoPlanControls,
    OrthoPlanButtons,
    OrthoTreatmentControls,
  },
  render(createElement, context) {
    // const orthoPlanShowOriginal = createElement(OrthoPlanControls, { props: { mode: OrthoPlanMode }});
    // context.props.treatmentContext = treatmentContext;
    // const orthoPlanButtons = createElement(OrthoPlanButtons, {
    //   props: context.props,
    // });
    // const orthoTreatmentControls = createElement(OrthoTreatmentControls, {
    //   props: context.props,
    // });
    //const orthoStageDialog = createElement(OrthoStageDialog, { props: context.props });
    // const orthoPlanSidePanel = createElement(OrthoPlanSidePanel, { props: { editContext: toothContext } });
    // const orthoPlanToothMetrics = createElement(OrthoPlanToothMetrics, { props: { editContext: toothContext } });

    return []; // [orthoPlanButtons, orthoTreatmentControls];
  },
};

async function downloadOrhoStages(callBack, isIntraoral) {
  let stageViewer = isIntraoral ? ioViewer : viewer;
  let gingivae = isIntraoral ? ioGingivae : vueApp.gingivae;
  if (stageViewer && gingivae) {
    gingivae.forEach((model) => {
      let mesh = stageViewer.get_model_mesh(model.id);
      if (!mesh.stages) {
        mesh.stages = {};
        mesh.stages[-1] = { geometry: mesh.geometry.clone() };
      }
    });
  }

  let stageLinks = await sendGetStageLinksRequest(isIntraoral);
  // console.log("stageLinks", stageLinks, isIntraoral);
  if (stageLinks && stageLinks.length) {
    const totalCount = stageLinks.length;
    let counter = 0;
    let stages = [];

    stageLinks.forEach((stageLink) => {
      let arr = stageLink.split("/");
      let zipName = arr[arr.length - 1];
      console.log("stage download start", zipName);
      JSZipUtils.getBinaryContent(stageLink, {
        progress: function (event) {
          // console.log("stage download progress", zipName, event.percent);
        },
        callback: function (err, zipData) {
          if (err) {
            console.log("stage download error", zipName, err);
            if (++counter == totalCount) {
              callBack(stages);
            }
          } else {
            console.log("stage download result", zipName, zipData);
            JSZip.loadAsync(zipData).then((zip) => {
              let stageDataZipFile = zip.file(STAGE_DATA_JSON);
              if (stageDataZipFile) {
                stageDataZipFile.async("string").then((text) => {
                  try {
                    let stage = JSON.parse(text);
                    if (stage.isIntraoral == !!isIntraoral) {
                      stage.link = stageLink;
                      // let existedStage = vueApp.orthoStages.find(
                      //   (s) => s.id == stage.id
                      // );
                      stage.teethString = JSON.stringify(stage.teeth);
                      if (stageViewer && gingivae) {
                        gingivae.forEach((model) => {
                          let stlZipFile = zip.file(model.filename);
                          // console.log(`Stage STL: ${model.filename}`, stlZipFile);
                          if (stlZipFile) {
                            stlZipFile.async("arraybuffer").then((buffer) => {
                              try {
                                let stageGeometry = getGeometryFromStl(buffer);
                                stageGeometry = toLegacyGeometry(stageGeometry);
                                let mesh = stageViewer.get_model_mesh(model.id);
                                if (!mesh.stages) mesh.stages = {};
                                mesh.stages[stage.id] = {
                                  geometry: stageGeometry,
                                };
                              } catch (e) {
                                console.log(
                                  `Invalid STL: ${model.filename}! Error: ${e}`
                                );
                              }
                            });
                          }
                        });
                      }
                      // vueApp.orthoStages.push(stage);
                      stages.push(stage);
                    }

                    if (++counter == totalCount) {
                      callBack(stages);
                    }
                  } catch (e) {
                    console.log(
                      `Invalid JSON: ${STAGE_DATA_JSON}! Error: ${e}`
                    );
                    if (++counter == totalCount) {
                      callBack(stages);
                    }
                  }
                });
              } else {
                if (++counter == totalCount) {
                  callBack(stages);
                }
              }
            });
          }
        },
      });
    });
  } else if (callBack) {
    callBack();
  }
}

function showLoader(isGray) {
  $id("loader").style.display = "block";
  if (isGray) {
    $id("loader").style.background = "gray";
    $id("loader").style.opacity = "0.7";
  }
  $("#loaderText").html(`Calculating data... Please wait`);
  $("#loaderText2").html(``);
  $("#loaderText3").html(``);
}

function hideLoader() {
  // console.log("hideLoader");
  $id("loader").style.display = "none";
}

function enterOrthoPlanMode(useLatest) {
  OrthoPlanMode.isWhite = vueApp.isWhite;
  OrthoPlanMode.whiteColor = vueApp.whiteColor;
  OrthoPlanMode.blueColor = vueApp.blueColor;
  OrthoPlanMode.isIntraoralView = vueApp.isIntraoralView;

  if (vueApp.isIntraoralView) {
    enterIntraoralOrtho();
  }

  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  vueApp.hideClipping();

  let allTeeth = vueApp.isIntraoralView
    ? allModels.filter((x) => x.isTooth)
    : vueApp.allTeeth;
  let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;

  if (!orthoViewer.isLaplacianLoaded) {
    showLoader(true);
    loadGingivaCrossData(orthoViewer, gingivae, allTeeth, true, () => {
      enterOrthoPlanMode(useLatest);
      hideLoader();
    });
    return;
  }

  if (
    vueApp.activeMode != OrthoPlanMode ||
    !OrthoPlanMode.isActive ||
    useLatest
  ) {
    console.log("enterOrthoPlanMode");
    initializeControls();
    vueApp.leaveModes(false, true, true);

    $(".ortho-mode-item").css("display", "block");
    if (vueApp.isIntraoralView) {
      $(".orto-no-intraoral").css("display", "none");
    }

    if (vueApp.isViewMode) {
      $(".ortho-save").css("display", "none");
      $("#orthoSaveButtons").css("left", "100px");
    }

    allTeeth.forEach(function (item) {
      orthoViewer.set_opacity(
        item.id,
        OrthoPlanMode.showCollisions || OrthoPlanMode.showAnchorageLoss
          ? 0.3
          : !item.extracted
          ? 1
          : 0.3
      );
    });
    vueApp.activeMode = OrthoPlanMode;
    OrthoPlanMode.isActive = true;

    let maxId = vueApp.getMaxOrthoStageId();
    if (useLatest && maxId > 0) {
      let tempName = OrthoPlanMode.stageName;
      loadOrthoStage(maxId, false, false);
      OrthoPlanMode.stageName = tempName;
    } else {
      vueApp.currentStageId = 0;
    }

    if (!vueApp.isIntraoralView) {
      findTeethCollisions();
      findTeethAnchorageLoss();
    }

    if (toothContext.id) {
      let tooth = vueApp.isIntraoralView
        ? allTeeth.find((x) => x.id == model.id)
        : vueApp.getItemById(toothContext.id);
      enterEditToothMode(tooth);
    } else {
      exitEditToothMode();
    }
  }
}

function initializeControls() {
  initializeOpacity();

  if (!controlsInitialized) {
    let ctrls = [
      OrthoStageDialog,
      OrthoPlanControls,
      OriginalTeethOpacity,
      OrthoTreatmentControls,
      OrthoPlanButtons,
      // OrthoPlayControls
    ]; // OrthoPlanToothMetrics OrthoPlanSidePanel2,
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: {
          editContext: toothContext,
          treatmentContext: treatmentContext,
          mode: OrthoPlanMode,
        },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("main_div").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });

    initMovementVector(movementVectorValueChanged);

    // canecode_switch("#orthoPlanOriginalButton");
    // canecode_switch("#moveShowTapArrowsButton");
    // canecode_switch("#orthoPlanExtractButton");

    // switchToggle("orthoPlanOriginalDiv", false);
    // switchToggle("moveShowTapArrowsDiv", false);
    // switchToggle("orthoPlanExtractDiv", false);
    controlsInitialized = true;
  }
}

// !!!
function leaveOrthoPlanMode(saveActiveMode) {
  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  clearOrtoAccesories();
  vueApp.currentStageId = -1;
  $(".ortho-mode-item").css("display", "none");
  if (!saveActiveMode) {
    vueApp.activeMode = null;
    exitEditToothMode();
  } else {
    let tempId = toothContext.id;
    exitEditToothMode();
    toothContext.id = tempId;
  }
  toothContext.id = null;
  toothContext.tooth = null;
  toothContext.selectedTeeth = [];
  OrthoPlanMode.isActive = false;

  // if (vueApp.isIntraoralView) loadOrthoStage(-1, false, false);
  vueApp.leaveModes(false, true, true);
  vueApp.restoreClipping();
  // vueApp.leaveModes();
}

function enterEditToothMode(tooth) {
  console.log("enterEditToothMode", toothContext);
  if (tooth) {
    if (toothContext.isMultiselect) {
      toothContext.id =
        toothContext.tooth =
        toothContext.defaultBox =
        toothContext.defaultPosition =
          null;
      if (!toothContext.selectedTeeth.includes(tooth))
        toothContext.selectedTeeth.push(tooth);
      else {
        let index = toothContext.selectedTeeth.indexOf(tooth);
        if (index >= 0) {
          toothContext.selectedTeeth.splice(index, 1);
        }
      }
      let isAnyNonExtracted = toothContext.selectedTeeth.find(
        (t) => !t.extracted
      );
      switchToggle("orthoPlanExtractDiv", isAnyNonExtracted ? false : true);
    } else {
      toothContext.id = OrthoPlanMode.selectedId = tooth.id;
      toothContext.tooth = tooth;
      toothContext.defaultBox = tooth.defaultBox;
      toothContext.defaultPosition = tooth.defaultPosition;
      toothContext.selectedTeeth = [];
      switchToggle("orthoPlanExtractDiv", tooth.extracted ? true : false);
    }

    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;
    allTeeth.forEach(function (item) {
      let mesh = orthoViewer.get_model_mesh(item.id);
      if (toothContext.selectedTeeth.includes(item)) {
        item.tempColor = "#FF0000";
        mesh.material.color = multiselectColor;
      } else {
        item.tempColor = null;
        mesh.material.color = new THREE.Color(item.color);
      }

      if (item.isVisible)
        orthoViewer.set_opacity(
          item.id,
          OrthoPlanMode.showCollisions ||
            OrthoPlanMode.showAnchorageLoss ||
            item.extracted
            ? 0.3
            : 1
        );
    });

    toothContext.isActive = true;
    toothContext.display =
      vueApp.isIntraoralView || toothContext.isMultiselect ? "none" : "block";

    //setTimeout(function () {
    if (toothContext.isRotated) enterRotateMode(toothContext);
    else enterMoveMode(toothContext);
    //}, 250);
  }
}

function updateToothMetrics(tooth, mesh) {
  if (tooth) {
    if (!mesh) mesh = orthoViewer.get_model_mesh(tooth.id);

    let defPosition = tooth.defaultPosition;
    let mesPos = mesh.position;
    toothContext.moveX = positiveZero((mesPos.x - defPosition.x).toFixed(1));
    toothContext.moveY = positiveZero((mesPos.y - defPosition.y).toFixed(1));
    toothContext.moveZ = positiveZero((mesPos.z - defPosition.z).toFixed(1));

    let rotation = mesh.rotation;
    toothContext.rotateX = positiveZero(
      radiansToDegrees(rotation.x).toFixed(1)
    );
    toothContext.rotateY = positiveZero(
      radiansToDegrees(rotation.y).toFixed(1)
    );
    toothContext.rotateZ = positiveZero(
      radiansToDegrees(rotation.z).toFixed(1)
    );
  }
}

function exitEditToothMode() {
  // if (toothContext.id) {
  //   let color = vueApp.getActualColor(toothContext.tooth);
  //   orthoViewer.set_color(toothContext.id, color);
  // }
  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  let allTeeth = vueApp.isIntraoralView
    ? allModels.filter((x) => x.isTooth)
    : vueApp.allTeeth;
  allTeeth.forEach(function (item) {
    item.tempColor = null;
    let mesh = orthoViewer.get_model_mesh(item.id);
    mesh.material.color = new THREE.Color(item.color);
    // mesh.moveRotateGroup = null;
    orthoViewer.set_opacity(
      item.id,
      OrthoPlanMode.showCollisions ||
        OrthoPlanMode.showAnchorageLoss ||
        item.extracted
        ? 0.3
        : 1
    );
  });

  // $("#orthoToothDoneButton").css("display", "none");
  // $("#orthoSaveButtons").css("display", "block");
  OrthoPlanMode.selectedId = null;

  toothContext.display = "none";
  toothContext.id = 0;
  toothContext.tooth = null;
  exitMoveMode();
  exitRotateMode();
}

function toggleExtract(tooth) {
  if (tooth) {
    tooth.extracted = !tooth.extracted;
    let mesh = orthoViewer.get_model_mesh(tooth.id);
    setToothMeshOpacity(tooth, mesh);
    // orthoViewer.set_opacity(tooth.id, !tooth.extracted ? 1 : 0.3); // item.isVisible &&
    switchToggle("orthoPlanExtractDiv", tooth.extracted);

    if (
      tooth.extracted &&
      toothContext.tooth == tooth &&
      !OrthoPlanMode.showExtracted
    ) {
      mesh.visible = mesh.isVisible = false;
      exitEditToothMode();
    }
  }
}

function toggleShowExtracted(newValue, divId = "orthoShowExtractedDiv") {
  if (OrthoPlanMode.showExtracted != newValue) {
    OrthoPlanMode.showExtracted = newValue;
    switchToggle(divId, OrthoPlanMode.showExtracted);
    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;
    let extractedTeeth = allTeeth.filter((t) => t.extracted);
    console.log("toggleShowExtracted", newValue, extractedTeeth.length);

    extractedTeeth.forEach(function (tooth) {
      let mesh = viewer.get_model_mesh(tooth.id);
      if (mesh) {
        mesh.visible = mesh.isVisible = OrthoPlanMode.showExtracted;

        if (tooth.extracted && toothContext.tooth == tooth) {
          if (OrthoPlanMode.showExtracted) {
            enterEditToothMode(tooth);
          } else {
            exitEditToothMode();
          }
        }
      }
    });

    // vueApp.bones.forEach(function (item) {
    // 	if (item.isVisible)
    // 		orthoViewer.set_color(item.id, vueApp.bonesColor);
    // });
  }
}

function toggleShowOriginal(newValue, divId = "orthoPlanOriginalDiv") {
  if (OrthoPlanMode.showOriginal != newValue) {
    OrthoPlanMode.showOriginal = newValue;
    switchToggle(divId, OrthoPlanMode.showOriginal);
    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;
    if (OrthoPlanMode.showOriginal) {
      // vueApp.bones.forEach(function (item) {
      // 	orthoViewer.set_color(item.id, "transparent");
      // });
      allTeeth.forEach(function (item) {
        let mesh = item.defaultMeshId
          ? orthoViewer.scene.getObjectById(item.defaultMeshId, true)
          : null;
        if (mesh) {
          mesh.material.color.set(original_teeth_color); // parseInt('ABA7A8', 16)
          mesh.isVisible = true;
          mesh.visible = item.isVisible;
          mesh.material.opacity = original_teeth_opacity;
        }
      });
    } else {
      allTeeth.forEach(function (item) {
        let mesh = orthoViewer.scene.getObjectById(item.defaultMeshId, true);
        if (mesh) {
          mesh.visible = mesh.isVisible = false;
        }
      });

      // vueApp.bones.forEach(function (item) {
      // 	if (item.isVisible)
      // 		orthoViewer.set_color(item.id, vueApp.bonesColor);
      // });
    }
  }
}

function toggleShowCollisions(
  newValue,
  forceUpdate,
  divId = "orthoPlanCollisionsDiv"
) {
  if (OrthoPlanMode.showCollisions != newValue || forceUpdate) {
    let isOriginal = vueApp.currentStageId === -1;

    if (newValue && !isOriginal && (!collisionsFound || forceUpdate)) {
      showLoader(true);
      setTimeout(() => {
        findTeethCollisions();
        collisionsFound = true;
        hideLoader();
        toggleShowCollisions(newValue);
      }, 100);
      return;
    }

    OrthoPlanMode.showCollisions = newValue;
    switchToggle(divId, OrthoPlanMode.showCollisions);

    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;

    allTeeth.forEach((tooth) => {
      let mesh = viewer.get_model_mesh(tooth.id);
      if (mesh) {
        setToothMeshOpacity(tooth, mesh);
        if (mesh.crossedMeshes) {
          mesh.crossedMeshes.forEach((cmesh) => {
            cmesh.visible = cmesh.isVisible =
              mesh.visible && OrthoPlanMode.showCollisions && !isOriginal;
          });
        }
      }
    });
  }
}

function toggleAnchorageLoss(
  newValue,
  forceUpdate,
  divId = "orthoPlanAnchorageLossDiv"
) {
  if (OrthoPlanMode.showAnchorageLoss != newValue || forceUpdate) {
    let isOriginal = vueApp.currentStageId === -1;
    if (newValue && !isOriginal && (!anchorageLossFound || forceUpdate)) {
      showLoader(true);
      setTimeout(() => {
        generateRootCrownMeshes();
        findTeethAnchorageLoss();
        anchorageLossFound = true;
        hideLoader();
        toggleAnchorageLoss(newValue);
      }, 100);
      return;
    }

    OrthoPlanMode.showAnchorageLoss = newValue;
    switchToggle(divId, OrthoPlanMode.showAnchorageLoss);

    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;

    allTeeth.forEach((tooth) => {
      let mesh = orthoViewer.get_model_mesh(tooth.id);
      if (mesh) {
        setToothMeshOpacity(tooth, mesh);
        if (mesh.anchorageLossMesh) {
          mesh.anchorageLossMesh.visible = mesh.anchorageLossMesh.isVisible =
            mesh.visible && OrthoPlanMode.showAnchorageLoss && !isOriginal;
        }
      }
    });
  }
}

function setToothMeshOpacity(tooth, mesh) {
  if (tooth && mesh) {
    let material = mesh.originalMaterial
      ? mesh.originalMaterial
      : mesh.material;
    material.opacity =
      OrthoPlanMode.showCollisions ||
      OrthoPlanMode.showAnchorageLoss ||
      tooth.extracted
        ? 0.3
        : 1;
  }
}

function saveOrthoChanges(stayInMode) {
  let stage = vueApp.orthoStages.find((s) => s.name == OrthoPlanMode.stageName);
  if (!stage) {
    let maxId = vueApp.getMaxOrthoStageId();
    stage = {
      id: maxId + 1,
      name: OrthoPlanMode.stageName,
      isIntraoral: vueApp.isIntraoralView,
    };
    vueApp.orthoStages.push(stage);
  }
  vueApp.currentStageId = stage.id;

  let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
  gingivae.forEach((model) => {
    let mesh = orthoViewer.get_model_mesh(model.id);
    if (!mesh.stages) mesh.stages = {};
    mesh.stages[vueApp.currentStageId] = { geometry: mesh.geometry.clone() };
  });

  let allTeeth = vueApp.isIntraoralView
    ? allModels.filter((x) => x.isTooth)
    : vueApp.allTeeth;
  let stageTeeth = [];
  allTeeth.forEach(function (model) {
    let mesh = orthoViewer.get_model_mesh(model.id);
    model.stagePosition = model.savedPosition = {
      x: mesh.position.x,
      y: mesh.position.y,
      z: mesh.position.z,
    };
    model.stageRotation = model.savedRotation = {
      x: mesh.rotation.x,
      y: mesh.rotation.y,
      z: mesh.rotation.z,
    };
    stageTeeth.push({
      id: model.id,
      number: model.number,
      name: model.name,
      filename: model.filename,
      stagePosition: model.stagePosition,
      stageRotation: model.stageRotation,
      extracted: model.extracted,
      guid: model.guid,
    });
    //model.savedExtracted = model.extracted;
    // model.isVisible = !model.extracted;
  });
  stage.teeth = stageTeeth;
  stage.teethString = JSON.stringify(stageTeeth);
  if (!vueApp.isIntraoralView) updateSavedData();

  //vueApp.savedData.orthoStages = JSON.parse(JSON.stringify(vueApp.orthoStages));
  if (!stayInMode) {
    leaveOrthoPlanMode();
  }
  if (!vueApp.isIntraoralView) saveViewerData();
  saveStageOnServer(stage);
}

function saveStageOnServer(stage) {
  if (stage) {
    const zip = new JSZip();
    let stageData = {
      id: stage.id,
      name: stage.name,
      isIntraoral: stage.isIntraoral,
      teeth: stage.teeth, // JSON.parse(stage.teethString)
      zipName: stage.isIntraoral
        ? `intraoralStage_${stage.id}.zip`
        : `cbctStage_${stage.id}.zip`,
    };
    zip.file(STAGE_DATA_JSON, JSON.stringify(stageData));
    // zip.file("teethData.json", stage.teethString);
    let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
    gingivae.forEach((model) => {
      let mesh = orthoViewer.get_model_mesh(model.id);
      let bufferGeometry = getBufferGeometry(mesh.geometry);
      let vmesh = new THREE.Mesh(bufferGeometry); // todo translate ?
      vmesh.geometry.computeBoundingBox();

      const stlExporter = new STLExporter();
      const data = stlExporter.parse(vmesh, { binary: true });
      const blob = new Blob([data], { type: "application/octet-stream" });
      zip.file(model.filename, blob);
    });
    zip
      .generateAsync({
        type: "blob",
      })
      .then(async (content) => {
        try {
          await sendOrthoSaveStageRequest(stageData, content);
        } catch (e) {
          console.error("!!! ERROR SAVING ORTHO CHANGES", e);
        }
      });
  }
}

// !!!
function loadOrthoStage(stageId, fromMenu, needAnimation) {
  console.log("loadOrthoStage", stageId);
  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  vueApp.currentStageId = stageId;
  if (!needAnimation) updateSliderValue(stageId);

  let stage = vueApp.orthoStages.find((x) => x.id === stageId);
  if (stage || stageId == -1) {
    let allTeeth = vueApp.isIntraoralView
      ? allModels.filter((x) => x.isTooth)
      : vueApp.allTeeth;

    if (stage) {
      let stageTeeth = JSON.parse(stage.teethString);
      stageTeeth.forEach(function (model) {
        let existedTooth = vueApp.isIntraoralView
          ? allTeeth.find((x) => x.id == model.id)
          : vueApp.getItemById(model.id, model.guid);
        if (!existedTooth) {
          existedTooth = allTeeth.find((x) => x.id == model.id);
        }

        let mesh = orthoViewer.get_model_mesh(existedTooth.id);
        setToothMeshOpacity(existedTooth, mesh);

        existedTooth.extracted = model.extracted;

        let savedPos = model.stagePosition;
        let savedRot = model.stageRotation;
        if (!mesh) mesh = model.mesh;
        let currentPos = mesh.position;
        let currentRot = mesh.rotation;

        mesh.needUpdate =
          currentPos.x != savedPos.x ||
          currentPos.y != savedPos.y ||
          currentPos.z != savedPos.z ||
          currentRot.x != savedRot.x ||
          currentRot.y != savedRot.y ||
          currentRot.z != savedRot.z;

        if (!mesh.needUpdate) return;

        if (needAnimation) {
          let position = mesh.position;
          orthoViewer.set_position(
            existedTooth.id,
            position.x,
            position.y,
            position.z
          );
          console.log("animate model", existedTooth.filename);
          orthoViewer.animate_model(existedTooth.id, {
            exact: {
              x: savedPos.x,
              y: savedPos.y,
              z: savedPos.z,
              rotationx: savedRot.x,
              rotationy: savedRot.y,
              rotationz: savedRot.z,
              msec: ANIMATE_STAGE_MS - 50,
            },
          });
          // scale:5,
        } else {
          mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
          mesh.rotation.set(savedRot.x, savedRot.y, savedRot.z);

          mesh.subvector = new THREE.Vector3(0, 0, 0);
          if (mesh.moveRotateGroup)
            mesh.moveRotateGroup.position.copy(mesh.position);
        }
      });
      OrthoPlanMode.stageName = stage.name;

      if (needAnimation) {
        setTimeout(() => {
          let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
          gingivae.forEach((model) => {
            let mesh = orthoViewer.get_model_mesh(model.id);
            if (mesh && mesh.stages && mesh.stages[stageId]) {
              mesh.geometry = mesh.stages[stageId].geometry; //.clone();
            }
          });
          toggleShowCollisions(OrthoPlanMode.showCollisions, true);
          toggleAnchorageLoss(OrthoPlanMode.showAnchorageLoss, true);

          // playNextStage();
          if (vueApp.currentStageId != 0) {
            updateSliderValue(vueApp.currentStageId);
            playNextStage();
          } else {
            vueApp.isOrthoPlaying = false;
          }
        }, ANIMATE_STAGE_MS);
      }
      if (fromMenu) {
        enterOrthoPlanMode();
      }
    } else if (stageId == -1) {
      allTeeth.forEach(function (model) {
        model.extracted = false;
        let mesh = orthoViewer.get_model_mesh(model.id);
        if (!mesh) mesh = model.mesh;
        let savedPos = vueApp.isIntraoralView
          ? new THREE.Vector3(0, 0, 0)
          : model.defaultPosition;
        let savedRot = { x: 0, y: 0, z: 0 };
        mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
        mesh.rotation.set(savedRot.x, savedRot.y, savedRot.z);
        // orthoViewer.set_opacity(model.id, 1);
      });
      // if (OrthoPlanMode.isActive) {
      //   leaveOrthoPlanMode();
      // }
    }
    if (fromMenu) {
      clearOrtoAccesories();
    }
    if (!needAnimation) {
      let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
      gingivae.forEach((model) => {
        let mesh = orthoViewer.get_model_mesh(model.id);
        if (mesh && mesh.stages && mesh.stages[stageId]) {
          mesh.geometry = mesh.stages[stageId].geometry.clone();

          // TODO: load laplacianMesh positions from geometry
          const laplacianMesh = mesh.laplacianMesh;
          if (laplacianMesh) {
            laplacianMesh.positions = laplacianMesh.savedPositions;
            laplacianMesh.savedPositions = JSON.parse(
              JSON.stringify(laplacianMesh.positions)
            );
          }
        }
      });
      toggleShowCollisions(OrthoPlanMode.showCollisions, true);
      toggleAnchorageLoss(OrthoPlanMode.showAnchorageLoss, true);
    }
  } else {
    console.log(`stage with id ${stageId} not found`);
  }
}

function cancelOrthoChanges() {
  loadOrthoStage(vueApp.currentStageId, false, false);

  exitEditToothMode();
  leaveOrthoPlanMode();
  return;

  vueApp.allTeeth.forEach(function (model) {
    resetToothPositionAndRotation(model);
    // model.extracted = model.savedExtracted;
    // model.extracted = !model.isVisible;

    let toothMesh = orthoViewer.get_model_mesh(model.id);
    if (toothMesh.moveRotateGroup) {
      orthoViewer.scene.remove(toothMesh.moveRotateGroup);
      toothMesh.moveRotateGroup = null;
    }
  });
  let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
  gingivae.forEach((model) => {
    let mesh = orthoViewer.get_model_mesh(model.id);
    if (mesh.stages && mesh.stages[vueApp.currentStageId]) {
      mesh.geometry = mesh.stages[vueApp.currentStageId].geometry.clone();
    } else mesh.geometry = mesh.originalGeometry;

    // const laplacianMesh = mesh.laplacianMesh;
    // laplacianMesh.positions = laplacianMesh.savedPositions;
    // laplacianMesh.savedPositions = JSON.parse(
    //   JSON.stringify(laplacianMesh.positions)
    // );
  });
}

function resetToothPositionAndRotation(tooth) {
  if (tooth) {
    let mesh = orthoViewer.get_model_mesh(tooth.id);
    let savedPos = tooth.savedPosition
      ? tooth.savedPosition
      : tooth.defaultPosition;
    let savedRot = tooth.savedRotation
      ? tooth.savedRotation
      : { x: 0, y: 0, z: 0 };
    mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
    if (mesh.moveRotateGroup) {
      mesh.moveRotateGroup.position.set(savedPos.x, savedPos.y, savedPos.z);
    }
    mesh.rotation.set(savedRot.x, savedRot.y, savedRot.z);
    mesh.subvector = null;
    updateToothMetrics(tooth, mesh);
    // toothContext.moveX = toothContext.moveY = toothContext.moveZ =
    // 	toothContext.rotateX = toothContext.rotate = toothContext.rotateZ = "0.0";
  }
}

function movementVectorValueChanged(value) {
  toothContext.sliderValue = value;
  if (toothContext.isMoved) {
    moveModeValueChanged(value);
  } else if (toothContext.isRotated) {
    rotateModeValueChanged(value);
  }
}

function updateSliderValue(stageId) {
  if (stageId != undefined) {
    let newValue = stageId < 0 ? stageId : stageId - 1;
    updatePlaySlider(vueApp.orthoStages.length - 1, newValue);
  }
}

function updatePlaySlider(max, value) {
  if (!playInitialized) {
    initMovementVector(
      playSliderChanged,
      "#playSlider",
      true, // horizontal
      -1, // min
      max,
      0.01, // step
      value
    );
    playInitialized = true;
  } else {
    updateSlider("#playSlider", max, value);
  }
}

function playSliderChanged(value) {
  let newValue = Math.floor(value);
  newValue = newValue == -1 ? -1 : newValue + 1;
  if (vueApp.currentStageId != newValue && !vueApp.isOrthoPlaying) {
    vueApp.currentStageId = newValue;
    loadOrthoStage(vueApp.currentStageId);
  }
}

function clearOrtoAccesories() {
  toggleShowCollisions(false);
  toggleShowOriginal(false);
  toggleAnchorageLoss(false);

  if (viewer) {
    vueApp.allTeeth.forEach((tooth) => {
      let mesh = viewer.get_model_mesh(tooth.id);
      if (mesh) {
        let originalMeshes = [mesh.defaultMesh, mesh.originalTreatmentMesh];
        originalMeshes.forEach((vmesh) => {
          if (vmesh) {
            vmesh.visible = false;
          }
        });

        if (mesh.crossedMeshes) {
          mesh.crossedMeshes.forEach((crossedMesh) => {
            viewer.scene.remove(crossedMesh);
          });
          mesh.crossedMeshes = [];
        }
        if (mesh.anchorageLossMesh) {
          viewer.scene.remove(mesh.anchorageLossMesh);
          mesh.anchorageLossMesh = null;
        }
        if (mesh.axisMesh) {
          mesh.axisMesh.visible = false;
        }
      }
    });
  }

  collisionsFound = false;
  anchorageLossFound = false;
}

function switchOrthoPlay(isPlaying) {
  if (vueApp.isOrthoPlaying != isPlaying) {
    vueApp.isOrthoPlaying = isPlaying;
    if (vueApp.isOrthoPlaying) {
      // clearOrtoAccesories();
      // if (vueApp.currentStageId == vueApp.orthoStages.length) {
      vueApp.currentStageId = -1;
      updateSliderValue(-1);
      loadOrthoStage(-1);
      // }
      playNextStage();
    }
  }
}

function playNextStage() {
  if (playInterval) {
    clearInterval(playInterval);
    playInterval = null;
  }

  if (vueApp.isOrthoPlaying) {
    let maxId = vueApp.getMaxOrthoStageId();
    let stageId = vueApp.currentStageId;
    let nextStageId = getNextStageId(stageId);

    if (stageId != maxId && nextStageId) {
      loadOrthoStage(nextStageId, false, true);
      // updateSliderValue(stageId);
      let counter = 0;
      playInterval = setInterval(function () {
        ++counter;
        let newValue = stageId + counter / 100;
        updateSliderValue(newValue);
      }, ANIMATE_STAGE_MS / 100);
    } else if (vueApp.isOrthoPlaying) {
      // loadOrthoStage(maxId, false, false);
      updateSliderValue(maxId);
      vueApp.isOrthoPlaying = false;
    }
  }
}

function getNextStageId(stageId) {
  let nextStageId = stageId == -1 ? 1 : stageId + 1;
  let existedStage = vueApp.currentStages.find((s) => s.id >= nextStageId);
  return existedStage ? existedStage.id : null;
}

function resetToInitial(tooth) {
  if (!tooth) return;

  tooth.extracted = false;
  orthoViewer.set_opacity(tooth.id, 1);
  let mesh = orthoViewer.get_model_mesh(tooth.id);
  if (!mesh) mesh = tooth.mesh;
  let savedPos = vueApp.isIntraoralView
    ? new THREE.Vector3(0, 0, 0)
    : tooth.defaultPosition;
  let savedRot = { x: 0, y: 0, z: 0 };
  mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
  mesh.rotation.set(savedRot.x, savedRot.y, savedRot.z);
  mesh.updateMatrix();
  mesh.updateMatrixWorld(true);
  mesh.updateWorldMatrix(true, true);

  moveModeMouseUp(null, mesh);
  // redrawMoveArrow();
  // applyRotateToGingiva();
  // loadOrthoStage(-1);
}

function resetToCurrent(tooth) {
  if (!tooth) return;

  let stage = vueApp.orthoStages.find((x) => x.id === vueApp.currentStageId);
  if (stage) {
    let stageTeeth = JSON.parse(stage.teethString);
    let model = stageTeeth.find((x) => x.id == tooth.id);
    if (model) {
      tooth.extracted = model.extracted;
      orthoViewer.set_opacity(
        tooth.id,
        !tooth.extracted ? 1 : extractedOpacity
      );
      let savedPos = model.stagePosition;
      let savedRot = model.stageRotation;
      let mesh = orthoViewer.get_model_mesh(tooth.id);
      mesh.position.set(savedPos.x, savedPos.y, savedPos.z);
      mesh.rotation.set(savedRot.x, savedRot.y, savedRot.z);
      mesh.updateMatrix();
      mesh.updateMatrixWorld(true);
      mesh.updateWorldMatrix(true, true);

      moveModeMouseUp(null, mesh);
      // redrawMoveArrow();
      // applyRotateToGingiva();
    }
  } else {
    resetToInitial(tooth);
  }
}

function findTeethCollisions() {
  console.log("findTeethCollisions");
  try {
    if (!csgEvaluator) {
      csgEvaluator = new Evaluator();
      csgEvaluator.attributes = ["position", "normal"];
      csgEvaluator.useGroups = false;
    }

    let allVolumes = vueApp.allTeeth.map((model) => {
      let mesh = viewer.get_model_mesh(model.id);
      let geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      geometry.computeBoundingBox();
      geometry.computeBoundingSphere();

      let box = geometry.boundingBox;

      let volume = {
        geometry: geometry,
        box: box,
        model: model,
        mesh: mesh,
        crossedVolumes: [],
      };
      if (mesh.crossedMeshes) {
        mesh.crossedMeshes.forEach((crossedMesh) => {
          viewer.scene.remove(crossedMesh);
        });
      }
      mesh.crossedMeshes = [];
      return volume;
    });

    allVolumes.forEach((toohVolume) => {
      setCrossedMeshes(toohVolume, allVolumes);
    });
  } catch (error) {
    console.log("findTeethCollisions ERROR", error);
  }
}

function findToothCollisions(tooth) {
  try {
    if (!csgEvaluator) {
      csgEvaluator = new Evaluator();
      csgEvaluator.attributes = ["position", "normal"];
      csgEvaluator.useGroups = false;
    }

    let toothVolume = null;
    let allVolumes = vueApp.allTeeth.map((model) => {
      let mesh = viewer.get_model_mesh(model.id);
      let geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      geometry.computeBoundingBox();
      geometry.computeBoundingSphere();

      let box = geometry.boundingBox;

      let volume = {
        geometry: geometry,
        box: box,
        model: model,
        mesh: mesh,
        crossedVolumes: [],
      };
      if (model == tooth) toothVolume = volume;
      return volume;
    });

    if (toothVolume) {
      setCrossedMeshes(toothVolume, allVolumes);
    }
  } catch (error) {
    console.log("findToothCollisions ERROR", error);
  }
}

function setCrossedMeshes(toothVolume, allVolumes) {
  const mesh = toothVolume.mesh;
  if (mesh.crossedMeshes) {
    mesh.crossedMeshes.forEach((crossedMesh) => {
      viewer.scene.remove(crossedMesh);
    });
  }
  mesh.crossedMeshes = [];

  if (
    Math.abs(mesh.position.x - mesh.defaultPosition.x) < 0.001 &&
    Math.abs(mesh.position.y - mesh.defaultPosition.y) < 0.001 &&
    Math.abs(mesh.position.z - mesh.defaultPosition.z) < 0.001 &&
    !mesh.rotation.x &&
    !mesh.rotation.y &&
    !mesh.rotation.z
  )
    return;

  allVolumes.forEach((nvl) => {
    if (nvl != toothVolume && nvl.box.intersectsBox(toothVolume.box)) {
      toothVolume.crossedVolumes.push(nvl);
    }
  });

  if (toothVolume.crossedVolumes.length > 0) {
    const brush1 = new Brush(toothVolume.geometry);
    brush1.updateMatrixWorld();

    toothVolume.crossedVolumes.forEach((cvolume) => {
      const cgeometry = cvolume.geometry;
      const brush2 = new Brush(cgeometry);
      brush2.updateMatrixWorld();

      const crossedMesh = csgEvaluator.evaluate(brush1, brush2, INTERSECTION);
      let crossedGeometry = crossedMesh.geometry;
      if (crossedGeometry.drawRange.count > 0) {
        crossedGeometry.computeBoundingBox();
        let crossedBox = offsetBox(crossedGeometry.boundingBox);
        if (crossedBox.size.x || crossedBox.size.y || crossedBox.size.z) {
          crossedMesh.center = new THREE.Vector3(
            crossedBox.center.x,
            crossedBox.center.y,
            crossedBox.center.z
          );
          crossedMesh.material = collisionMaterial;
          crossedMesh.visible = OrthoPlanMode.showCollisions;
          viewer.scene.add(crossedMesh);
          mesh.crossedMeshes.push(crossedMesh);
          crossedMesh.model1 = toothVolume.model;
          crossedMesh.model2 = cvolume.model;
        }
      }
    });
  }
}

function findTeethAnchorageLoss() {
  try {
    vueApp.allTeeth.forEach((tooth) => findToothAnchorageLoss(tooth));
  } catch (error) {
    console.log("findTeethAnchorageLoss ERROR", error);
  }
}

function findToothAnchorageLoss(tooth) {
  try {
    if (!tooth) return;
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (!toothMesh) return;

    if (toothMesh.anchorageLossMesh) {
      viewer.scene.remove(toothMesh.anchorageLossMesh);
      toothMesh.anchorageLossMesh = null;
    }

    if (
      Math.abs(toothMesh.position.x - toothMesh.defaultPosition.x) < 0.001 &&
      Math.abs(toothMesh.position.y - toothMesh.defaultPosition.y) < 0.001 &&
      Math.abs(toothMesh.position.z - toothMesh.defaultPosition.z) < 0.001 &&
      !toothMesh.rotation.x &&
      !toothMesh.rotation.y &&
      !toothMesh.rotation.z
    )
      return;

    if (!csgEvaluator) {
      csgEvaluator = new Evaluator();
      csgEvaluator.attributes = ["position", "normal"];
      csgEvaluator.useGroups = false;
    }

    if (
      vueApp.hasClosedBones &&
      toothMesh.rootGeometry &&
      toothMesh.boneBrush
    ) {
      // console.log("findToothAnchorageLoss", tooth);
      let geometry = toothMesh.rootGeometry.clone();
      toothMesh.updateMatrix();
      geometry.applyMatrix4(toothMesh.matrix);

      let toothBrush = new Brush(geometry);
      toothBrush.updateMatrixWorld();

      let rootMesh = csgEvaluator.evaluate(
        toothBrush,
        toothMesh.boneBrush,
        SUBTRACTION
      );
      rootMesh.geometry.computeBoundingBox();
      let box = offsetBox(rootMesh.geometry.boundingBox);

      let minSize = 0;
      if (
        box.size.x > minSize &&
        box.size.y > minSize &&
        box.size.z > minSize
        // && rootMesh.geometry.drawRange.count > 1000
      ) {
        rootMesh.material = collisionMaterial;
        rootMesh.visible = OrthoPlanMode.showAnchorageLoss;
        viewer.scene.add(rootMesh);
        toothMesh.anchorageLossMesh = rootMesh;
      }
    }
  } catch (error) {
    console.log("findToothAnchorageLoss ERROR", error);
  }
}

function findAngulations(angulationAngle, isOriginal) {
  if (isNaN(angulationAngle)) angulationAngle = 10;
  let maxAngulation = 60;

  let angulations = {};
  for (const tooth of vueApp.allTeeth) {
    let mesh = viewer.get_model_mesh(tooth.id);
    if (mesh.axisMesh) {
      viewer.scene.remove(mesh.axisMesh);
      mesh.axisMesh = null;
    }

    let toothMax = new THREE.Vector3(
      tooth.defaultBox.center.x,
      tooth.defaultBox.max.y,
      tooth.defaultBox.center.z
    );
    let toothMin = new THREE.Vector3(
      tooth.defaultBox.center.x,
      tooth.defaultBox.min.y,
      tooth.defaultBox.center.z
    );
    let toothApex = tooth.apex;
    if (!toothApex) {
      toothApex = tooth.isMaxilla ? toothMin : toothMax;
    }
    toothApex = new THREE.Vector3(toothApex.x, toothApex.y, toothApex.z);

    let toothRoot = tooth.root;
    if (!toothRoot) {
      toothRoot = tooth.isMaxilla ? toothMax : toothMin;
    }
    toothRoot = new THREE.Vector3(toothRoot.x, toothRoot.y, toothRoot.z);

    let distance = calculateDistance(toothApex, toothRoot);

    let apex = (tooth.actualApex = toothApex
      .sub(mesh.defaultPosition)
      .applyMatrix4(mesh.matrix));
    let root = (tooth.actualRoot = toothRoot
      .sub(mesh.defaultPosition)
      .applyMatrix4(mesh.matrix));
    let coef = (distance + 5) / distance;

    let ax = (apex.x - root.x) * coef + root.x;
    let ay = (apex.y - root.y) * coef + root.y;
    let az = (apex.z - root.z) * coef + root.z;
    tooth.indentedApex = new THREE.Vector3(ax, ay, az);

    let rx = (root.x - apex.x) * coef + apex.x;
    let ry = (root.y - apex.y) * coef + apex.y;
    let rz = (root.z - apex.z) * coef + apex.z;
    tooth.indentedRoot = new THREE.Vector3(rx, ry, rz);

    mesh.axisMesh = drawAxisLine(tooth.indentedApex, tooth.indentedRoot);
    viewer.scene.add(mesh.axisMesh);
    mesh.axisMesh.visible = false;
  }

  for (const tooth of vueApp.allTeeth) {
    let mesh = viewer.get_model_mesh(tooth.id);
    if (isOriginal || mesh.rotation.x || mesh.rotation.y || mesh.rotation.z) {
      let neighborTeeth = vueApp.allTeeth.filter((t) => {
        if (Math.abs(t.number - tooth.number) === 1) return true;
        if (t.number === 11 && tooth.number === 21) return true;
        if (t.number === 21 && tooth.number === 11) return true;
        if (t.number === 31 && tooth.number === 41) return true;
        if (t.number === 41 && tooth.number === 31) return true;
        return false;
      });

      for (let ntooth of neighborTeeth) {
        let modelArr = [tooth, ntooth];
        modelArr.sort((m1, m2) => m1.number - m2.number);
        let angulationKey = `${modelArr[0].number}-${modelArr[1].number}`;
        let angle = calculateAngle(tooth, ntooth);
        if (
          !angulations[angulationKey] &&
          angle >= angulationAngle &&
          angle < maxAngulation
        ) {
          let collisionObj = {
            models: modelArr,
            model1: modelArr[0],
            model2: modelArr[1],
            imgData: null,
            angle: angle,
          };
          angulations[angulationKey] = collisionObj;
        }

        // console.log("angle", tooth.number, ntooth.number, angle);
        // let angulation = {
        //   model1:
        // }
        // angulations.push
      }
    }
  }

  // console.log("findAngulations", angulations);
  return angulations;
}

function drawAxisLine(point1, point2, radius) {
  if (!radius) {
    radius = 0.2;
  }
  let curve = new THREE.LineCurve3(point1, point2);
  let tubeGeometry = new THREE.TubeGeometry(
    curve,
    1, // tubularSegments
    radius, // radius
    8, // radialSegments
    false // closed
  );
  let line = new THREE.Mesh(tubeGeometry, collisionMaterial);
  return line;
}

function calculateAngle(tooth1, tooth2) {
  let a1 = tooth1.actualRoot;
  let b1 = tooth1.actualApex;
  let a2 = tooth2.actualRoot;
  let b2 = tooth2.actualApex;

  // drawLine(a1, b1);
  // drawLine(a2, b2);
  let dx = a2.x - a1.x;
  let dy = a2.y - a1.y;
  let dz = a2.z - a1.z;
  const t1 = new THREE.Vector3(b2.x - dx, b2.y - dy, b2.z - dz);
  // drawLine(a1, t1, 0x00ff00);

  const v0 = new THREE.Vector3(0, 0, 0);
  const v1 = new THREE.Vector3(b1.x - a1.x, b1.y - a1.y, b1.z - a1.z);
  const v2 = new THREE.Vector3(t1.x - a1.x, t1.y - a1.y, t1.z - a1.z);
  // drawLine(v0, v1, 0x0000ff);
  // drawLine(v0, v2, 0x0000ff);

  let angleRadians = v1.angleTo(v2);
  const angleDeg = THREE.MathUtils.radToDeg(angleRadians); // angleRadians * 180 / Math.PI
  return angleDeg;
}

export {
  OrthoPlanMode,
  treatmentContext,
  toothContext,
  initializeControls,
  enterOrthoPlanMode,
  leaveOrthoPlanMode,
  exitEditToothMode,
  resetToothPositionAndRotation,
  toggleShowOriginal,
  toggleShowExtracted,
  toggleShowCollisions,
  clearOrtoAccesories,
  toggleAnchorageLoss,
  saveOrthoChanges,
  loadOrthoStage,
  cancelOrthoChanges,
  toggleExtract,
  STAGE_DATA_JSON,
  ANIMATE_STAGE_MS,
  downloadOrhoStages,
  updateSliderValue,
  switchOrthoPlay,
  resetToInitial,
  resetToCurrent,
  updatePlaySlider,
  playSliderChanged,
  findToothCollisions,
  findToothAnchorageLoss,
  findTeethCollisions,
  findTeethAnchorageLoss,
  findAngulations,
  showLoader,
  hideLoader,
};
